<template>
  <div class="container">
    <div class="row">
      <h3 class="col-4 page-heading">Updates</h3>
    </div>
    <div class="signup-content">
      <h3>COMING SOON</h3>
    </div>
  </div>
</template>

<script>

export default {
  data () {
    return {}
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/Updates.vue